import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function deleteSocialPage(id: number): Promise<void> {
  await apiClient.url(`/social-publishing/pages/${id}`).delete().res();
}

export function useDeleteSocialPage(): UseMutationResult<void, Error, number> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSocialPage,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: socialPublishingKeys.pages(),
      });
    },
  });
}
